module.exports = __webpack_public_path__ + "img/photo-2.361d4882.jpg";